import { AcpEnvironment } from 'apps/acp/packages/acp-config';

export const getAcpConfig = (): AcpEnvironment => window.acp;
